import types from './types';

const setExportsInfo = (exportsInfo) => ({ type: types.SET_EXPORTS_INFO, payload: exportsInfo });
const setLoading = (loading) => ({ type: types.SET_LOADING, payload: loading });

export default {
    setExportsInfo,
    setLoading
};
